export const APP_BASE_PATH = '/App';
export const TRIAL_BASE_PATH = '/Trial';
